import { missionAccessControlType } from '../../../../backend/extraTypes';
import { classifierColumns, classifierSchema } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
export const missionTypeEntityName = 'missionType';
export const missionTypeSchema = classifierSchema.extend({
    missionAccessControl: z.enum(missionAccessControlType),
});
export const missionTypeColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { missionAccessControl: { type: 'string-required' }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
